import { InternalApiError } from "../../model/ApiError";
import { generateRandomUuid } from "../../util/uuidUtil";

abstract class MockBase {
  initialize(initProvider: (name: string) => string): void {}

  protected undefinedTo404<T>(obj?: T): T {
    if (obj) {
      return obj;
    }

    throw this.build404();
  }

  protected emptyTo404<T>(objs?: T[]): T[] {
    if (objs && objs.length !== 0) {
      return objs;
    }

    throw this.build404();
  }

  protected minusOneTo404(index: number): number {
    if (index !== -1) {
      return index;
    }

    throw this.build404();
  }

  protected build404() {
    return new InternalApiError("not_found", "Resource not found");
  }

  protected buildTestError() {
    return new InternalApiError("test_error", "A failure waiting to happen");
  }

  protected notMinusOneTo409(index: number): number {
    if (index === -1) {
      return index;
    }

    throw this.build409();
  }

  protected build409() {
    return new InternalApiError(
      "conflict",
      "Conflict / resource already exists"
    );
  }

  protected randomUuid(): string {
    return generateRandomUuid();
  }
}

export default MockBase;
